import { Route } from "react-router-dom";
import ProviderChatList from "../components/index";
import DefaultProviderChat from "../../provider-chat/components/DefualtChat";
import ProviderChat from "../../provider-chat/components/index";
import ProviderMiddleware from "../../provider-middleware/components/index";

const ProviderChatListRoutes = () => (
  <>
    <Route path="/chat/:type" element={<ProviderMiddleware><ProviderChatList /></ProviderMiddleware>}>
        <Route index element={<DefaultProviderChat />} />
        <Route path=":id/:chatId?" element={<ProviderChat />} />
    </Route>
  </>
);

export default ProviderChatListRoutes;
